import { abbreviateNumber } from '@wiggot/utils'

export const CustomYAxis = ({
  x,
  y,
  index,
  payload
}: {
  x?: number
  y?: number
  index?: number
  payload?: {
    value: any
  }
}) => {
  if (index === 0) {
    return null
  }

  const value = abbreviateNumber({ value: payload?.value, compact: true })

  return (
    <g>
      <text
        x={(x ?? 0) - 4}
        y={y}
        textAnchor="end"
        alignmentBaseline="middle"
        fill="#7E87A7"
        fontSize={12}
      >
        {value.number}
        {value.notation}
      </text>
    </g>
  )
}

export const CustomXAxis = ({
  x,
  y,
  payload
}: {
  payload?: {
    index: number
    value: string
  }
  x?: number
  y?: number
}) => {
  return (
    <g>
      <text
        x={x}
        y={(y ?? 0) + 12}
        textAnchor="middle"
        fontSize={12}
        fontWeight={700}
      >
        {payload?.value}
      </text>
    </g>
  )
}
